import sdl from '@jds/react-generated-sdl/JDSStepperDot';
import type { JDSStepperDotProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSStepperDotProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    state = 'inactive',
    itemsType = 'numbered',
    activeState = 'normal',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { state, itemsType, activeState, ...rest },
    'JDSStepperDot',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const StepperDot = withLogic(Component) as React.FC<JDSStepperDotProps> & {
  slotName?: string;
};

StepperDot.displayName = 'StepperDot';
StepperDot.slotName = 'jds_stepper_dot';

export { StepperDot, type JDSStepperDotProps };
